import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import { useNavigate } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../config/firebase-config';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, loginWithGoogle } = useAuth();
  const { addToast } = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      addToast('Login successful!', 'success');
      navigate('/');
    } catch (err) {
      setError(err.message);
      addToast(err.message || 'Login failed', 'error');
    }
  };

  const handleGoogle = async () => {
    try {
      await loginWithGoogle();
      addToast('Login successful!', 'success');
      navigate('/');
    } catch (err) {
      setError(err.message);
      addToast(err.message || 'Google login failed', 'error');
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      addToast('Please enter your email to reset password', 'error');
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      addToast('Password reset email sent!', 'success');
    } catch (err) {
      addToast(err.message || 'Failed to send reset email', 'error');
    }
  };

  return (
    <section className="auth-panel">
      <h2>Login</h2>
      {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="row">
          <label>
            <div className="label-text">Email</div>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </label>
          <label>
            <div className="label-text">Password</div>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          </label>
        </div>
        <button className="btn" type="submit">Login</button>
      </form>
      <button className="btn" onClick={handleGoogle} style={{ background: '#4285f4', marginTop: 10 }}>Login with Google</button>
      <button className="btn" onClick={handleForgotPassword} style={{ background: '#f59e0b', marginTop: 10 }}>Forgot Password</button>
      <p>Don't have an account? <a href="/signup">Sign up</a></p>
    </section>
  );
}